import cl from 'clsx'
import styles from './styles.module.css'

/**
 * @param {string} title     Main heading (single string, wraps naturally)
 * @param {string} titleSm   Small uppercase label above the heading
 * @param {string} color     "white" — switches colors for dark backgrounds
 * @param {string} position  "how" | "testimonials" — section-specific width tweaks
 */
export default function Title({ title, titleSm, color, position }) {
    return (
        <div className={styles.title} data-name="title">
            {titleSm && (
                <div
                    className={cl(
                        styles.title__first,
                        color === 'white' && styles.title__first_color,
                        position === 'how' && styles.title__color_50
                    )}
                >
                    {titleSm}
                </div>
            )}
            <div
                className={cl(
                    position === 'how' && styles.title__how,
                    position === 'testimonials' && styles.title__testimonials
                )}
            >
                <h2
                    className={cl(
                        styles.title__second,
                        color === 'white' && styles.title__white
                    )}
                >
                    {title}
                </h2>
            </div>
        </div>
    )
}
